import { ReactComponent as PhoneSvg } from '../../assets/icons/phone.svg';

export const PhoneIcon: SvgIcon = (props) => {
    return <PhoneSvg {...props} />;
};
